import {useCallback, useEffect, useRef, useState} from "react";
import {useHistory, useLocation, useParams} from 'react-router-dom';

import {Grid} from "@material-ui/core";

import Breadcrumbs from "@base/Breadcrumbs";
import Toast from "@base/Toast";
import BuscaEscola from '@base/Inputs/BuscaEscola'
import Title from "@base/Title";
import Subtitle from "@base/Subtitle";
import VisualizadorDeArquivo from '@base/VisualizadorDeArquivo';

import TextField from "@base/Inputs/Text"
import File from '@base/Inputs/File';

import escolaService from "@services/EscolaService";

import DeForm from "@shared/DeForm";

import {ProcessoResolver} from "@helpers/ProcessoHelper";
import {documentoEnvioMask} from "@helpers/MaskHelper";

export const DigitarDe = (props) => {

	const [escolaSelecionada, setEscolaSelecionada] = useState({});
	const history = useHistory();
	const params = useParams();
	const processo = ProcessoResolver(params.processo);
	const location = useLocation();
	const [inepInformado, setInepInformado] = useState(params.escola ? params.escola : "");
	const pageName = `Digitação de DE`;
	const inputEl = useRef(null);
	const toastRef = useRef(null);
	const [blob, setBlob] = useState();
	const [deId, setDeId] = useState(params.id ? params.id : "IMPA");
	const [deIlegivel, setDeIlegivel] = useState(false);
  const [formulario, setFormulario] = useState({
    codigoDE: "",
    mensagem: "",
    status: "",
    tipoArquivoDE: "",
    arquivoDE: "",
    })

  const imageMimeTypes = ['image/jpeg', 'image/png'];
  const regex = /^\d{2}[A-Za-z]{2}\d{8}$/;

  const carregarEscola = useCallback(() => {

		if (inepInformado.length === 8) {

			escolaService.listarPorCodigoInepOuEticket(params.processo, inepInformado)
				.then(resposta => {

					if (resposta.status === 200) {
						setEscolaSelecionada(resposta.data);
					} else {
						toastRef.current.show("warning", "Código INEP não encontrado.");
					}

					escolaService.buscarDadosDoDE(params.processo, inepInformado, deId).then(resposta => {
						setDeIlegivel(resposta.data.arquivoLegivel !== undefined && resposta.data.arquivoLegivel === false);
					});

					escolaService.downloadDE(params.processo, inepInformado, deId)
						.then(resultado => {
              if (resultado.status === 200){
                setBlob(resultado.data);
                setDeId(deId);
                setFormulario(prevState => ({
                  ...prevState,
                  status:  "REGISTRADO",
                  arquivoDE: resultado.data,
                }));
              }

						}).catch(erro => {
							toastRef.current.show("error", "Não foi posível fazer download do arquivo.");
						});

				}).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao Buscar a Escola."));
		} else if (inepInformado.length < 8) {
			setEscolaSelecionada({});
		}

	}, [inepInformado, params.processo, deId]);

	useEffect(() => carregarEscola(), [carregarEscola]);

  const isImage = (type) => imageMimeTypes.includes(type);
  const deFormatada = (arquivo) => {

    setBlob(arquivo);
    const novoCodigoDE = tratarCodigo(arquivo.name);
    console.log(regex.test(novoCodigoDE));

    setFormulario(prevState => ({
      ...prevState,
      codigoDE: novoCodigoDE,
      tipoArquivoDE: arquivo.type,
      mensagem: isImage(arquivo.type) ? regex.test(novoCodigoDE) ? "Não Registrado" : "O código deve possuir 12 caracteres, ignore a última letra." : "Arquivo não é uma imagem",
      status: isImage(arquivo.type) && regex.test(novoCodigoDE) ? "NAO_REGISTRADO" : "ERRO",
      arquivoDE: arquivo,
    }));
  }

	const reset = () => {
		toastRef.current.show("success", "DE digitado com sucesso!");

		if (location.state && location.state.codigoInep) {
			setTimeout(() => history.goBack(), 1000);
		} else {
			setEscolaSelecionada({});
			setBlob("");
			setInepInformado("");
			inputEl.current.focus();
		}
	}

  const tratarCodigo = (codigo) => {
    const regex = /[.\-_].*/;
    codigo = codigo.replace(regex, '');
    if (codigo.length > 12) {
      codigo = codigo.substring(0, 12);
    }
    return codigo
  }

	const breadcrumbs = [
		{
			path: `/${processo.id}/escolas`,
			name: "Escolas"
		},
		{
			path: `/${processo.id}/escola/${escolaSelecionada.codigoInep}`,
			name: escolaSelecionada.nome
		}
	];

	const aoMarcarDeComoIlegivel = () => {
		escolaService.deIlegivel(params.processo, inepInformado, deId).then(arquivo => {
			setDeIlegivel(true);
		});

	}

  const mudarcodigo = (codigo) => {
    setFormulario(prevState => ({
      ...prevState,
      codigoDE: codigo,
      status: regex.test(codigo) ? "NAO_REGISTRADO" : "ERRO",
      mensagem: regex.test(codigo) ? "Não Registrado" : "O código deve possuir 12 caracteres, ignore a última letra"
    }));

  };

	return (
		<>
			<Toast ref={toastRef} />
			{(location.state && location.state.codigoInep) || escolaSelecionada.id ?
				<>
					<Grid container spacing={3}>
						<Grid item xs={12}>
							<Breadcrumbs links={breadcrumbs} active={pageName} />
						</Grid>
					</Grid><br />

					<Title>{escolaSelecionada.nome}</Title>
					<Subtitle>{pageName}</Subtitle><br />
				</>
				:
				<>
					<Title>{pageName}</Title><br />

					<BuscaEscola
						size={6}
						inputRef={inputEl}
						autoFocus
						disabled={location.state && location.state.codigoInep}
						processo={processo}
						aoencontrar={(escola) => {
							setEscolaSelecionada(escola);
							setInepInformado(escola.codigoInep);
						}}
					/>
				</>
			}

			{escolaSelecionada.id &&

				<>
					<Grid container sm={12} lg={12}>

						<Grid item sm={6} lg={6}>
							<TextField
								autoFocus
								required
								label="INEP"
								value={escolaSelecionada.codigoInep}

								disabled={true}
							/>
						</Grid>
						<Grid item sm={6} lg={6}>
							<TextField
								autoFocus
								required
								label="Nome"
								value={escolaSelecionada.nome}

								disabled={true}
							/>
						</Grid>
					</Grid>

          <Grid container sm={12} lg={12} spacing={2}>

            <Grid item sm={5} lg={5}>
              <DeForm
                id={deId}
                processo={processo.id}
                escola={escolaSelecionada.codigoInep ?? inepInformado}
                onUpdate={reset}
                documentoEnvio={formulario}
              />
            </Grid>

            <Grid item sm={7} lg={7}>
              <Grid container sm={12} lg={12} spacing={2}>
                <Grid item sm={12} lg={12}>
                  {formulario.status !== "REGISTRADO" &&
                    <>
                      <File handleUpload={deFormatada}/>

                      {blob && isImage(blob.type) ?
                        <TextField
                          error={formulario.status === "ERRO"}
                          disabled={formulario.status === "DESABILITADO" || formulario.status === "REGISTRADO"}
                          label="Código do Documento de Envio"
                          value={formulario.codigoDE}
                          helperText={formulario.mensagem}
                          onChange={(e) => {
                            mudarcodigo(documentoEnvioMask(e.target.value))
                          }}
                        />
                        : formulario.status === "ERRO" && toastRef.current.show("error", "O arquivo não é uma imagem, Insira uma imagem válida.")
                      }
                    </>}

                </Grid>

                {blob ? <>
                  <Grid item sm={12} lg={12}>
                    <VisualizadorDeArquivo
                      ilegivel={deIlegivel}
                      aoMarcarComoIlegivel={aoMarcarDeComoIlegivel}
                      blob={blob}/>
                  </Grid></> : <></>}

              </Grid>
            </Grid>

          </Grid>
				</>
			}
		</>
	);
}

export default DigitarDe;
